import http from '../../utils/fetch';


export default {

    companyPrice:'/api/swyl/v1/price/companyMaterialInfoPrice',


    selectPage(q){
        return http({
            url: this.companyPrice + '/selectPage',
            method: 'post',
            params: q
        });
    },

    checkByCode(q) {
        return http({
            url: this.companyPrice + '/checkByCode',
            method: 'post',
            params: q
        });
    },

    adddingjia(q) {
        return http({
            url: this.companyPrice + '/adddingjia',
            method: 'post',
            data: q
        });
    },

    getliucheng(q){
        return http({
            url: this.companyPrice + '/getliucheng',
            method: 'post',
            params: q
        });
    },
    companySetPrice(q){
        return http.post(this.companyPrice + '/companySetPrice',q);
    },

    //删除定价
    toDelete(shenpibanben) {
        return http.post(this.companyPrice+'/toDelete?shenpibanben=' + shenpibanben);
    },
    //根据id查询
    selectById(id) {
        return http.post(this.companyPrice+'/selectById?id=' + id);
    },

    //根据审批版本查询
    selectByBanben(shenpibanben) {
        return http.post(this.companyPrice+'/selectByBanben?shenpibanben=' + shenpibanben);
    },



}